import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ProgressEntry } from '../video';

const LinearProgressWithLabel = ({
  value,
}: {
  value: ProgressEntry;
}): JSX.Element => {
  const { stage, progress } = value;
  console.log(progress);
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body1">
        {stage === 'transcoding'
          ? 'Video wird transkodiert'
          : 'Video wird upgeloaded'}
      </Typography>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${
          (progress * 100).toFixed(2) || 0
        }%`}</Typography>
      </Box>
    </Box>
  );
};

export default LinearProgressWithLabel;
